import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const badges = [
  { key: 'pci', icon: 'security', color: 'from-green-500/15 to-green-900/5', borderColor: 'border-green-500/30', iconColor: 'text-green-400' },
  { key: 'aml', icon: 'policy', color: 'from-purple-primary/15 to-accent-magenta/5', borderColor: 'border-purple-primary/30', iconColor: 'text-purple-primary' },
  { key: 'encryption', icon: 'encrypted', color: 'from-blue-500/15 to-blue-900/5', borderColor: 'border-blue-500/30', iconColor: 'text-blue-400' },
  { key: 'kyb', icon: 'verified_user', color: 'from-purple-primary/15 to-accent-magenta/5', borderColor: 'border-purple-primary/30', iconColor: 'text-accent-magenta' },
  { key: 'ofac', icon: 'gavel', color: 'from-amber-500/15 to-amber-900/5', borderColor: 'border-amber-500/30', iconColor: 'text-amber-400' },
];

export default function ComplianceStrip() {
  const { t } = useTranslation();

  return (
    <motion.section
      className="py-10 bg-transparent"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="mx-auto min-w-0 max-w-6xl px-4 sm:px-6">
        <div className="flex flex-wrap justify-center items-stretch gap-3 md:gap-4">
          {badges.map((b, i) => (
            <motion.div
              key={b.key}
              className={`flex items-center gap-3 px-5 py-3.5 rounded-xl bg-gradient-to-r ${b.color} border ${b.borderColor} cursor-default group`}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.4 }}
              whileHover={{ scale: 1.05, y: -2 }}
            >
              <div className={`w-9 h-9 rounded-lg bg-black/30 border ${b.borderColor} flex items-center justify-center flex-shrink-0`}>
                <span className={`material-symbols-outlined ${b.iconColor} text-[20px]`}>{b.icon}</span>
              </div>
              <div className="leading-tight">
                <span className="text-sm font-bold font-headline text-white block">{t(`complianceStrip.${b.key}.label`)}</span>
                <span className="text-[11px] text-on-surface-variant/60 font-label">{t(`complianceStrip.${b.key}.sub`)}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
